import React from 'react';
import AuthContainer from '../index';
import FormUserLogin from './forms/FormsUserLogin';
import FormsPersonalInfo from './forms/FormsPersonalInfo';
import FormsCompanyInfo from './forms/FormsCompanyInfo';
import Stepper from '../../../components/molecules/steppers';
import useSignup from './hooks';

function Signup(): React.ReactElement {
  const {
    step, handleStep, formikStep1, formikStep2, formikStep3, isLoading,
  } = useSignup();

  /* label for each step in stepper */
  const stepperComponents = [
    { label: 'User Login', component: <FormUserLogin formik={formikStep1} /> },
    { label: 'Personal Info', component: <FormsPersonalInfo formik={formikStep2} /> },
    { label: 'Company Info', component: <FormsCompanyInfo formik={formikStep3} isLoading={isLoading} /> },
  ];

  return (
    <AuthContainer
      title="Signup"
      description="Your one-stop solution for vending management!"
      onBack={step > 0 ? () => handleStep(step - 1) : undefined}
      askText={['Already have an account?', 'Login!']}
      askLink="/login"
    >
      <div className="w-100 mt-2">
        <Stepper.Kebab step={step} components={stepperComponents} />
      </div>
    </AuthContainer>
  );
}

export default Signup;
